// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
let backendHost = 'https://farmercusl.eastus.cloudapp.azure.com:8087'
let host = 'wss://farmercusl.eastus.cloudapp.azure.com:8087'
export const environment = {
  debounce_time: 500,
  production: false,
  webSocketUrl:`${host}/ws-chat/websocket`,
  authUrl: `${backendHost}/web/`,
  baseUrl: `${backendHost}/web/`,
  recaptchaEnterpriseSiteKey: "6LeZFOUpAAAAAFLMcZK262SCjWC6QN6fzWGDtp3a",
  fcmAuth: 'key=AAAAGXsLZt0:APA91bHYTy51T1a3Pi7Htx9eIC8TQUK-9QwRgyBUiCRzZhTzys-b6BOM3kMks1GJn1QAnZ5F_I5NG9vxZ29Cg0NpLm0v3J7F02Yo9H0Lm6vxAqjtuJRvAa2GeLMpxYfs2amSjnQq1BPG',
  encryptKey: "1298",
  emailUrl: "https://srilankamailapi.azurewebsites.net/api/sendmail",
  emailAuth: "qbV6sCfHrZPoSQ0caoIWoBfsn6uPeqbwJbwXw38eLNZ8AzFus7QP7g==",
  tentId: '4fc2f3aa-31c4-4dcb-b719-c6c16393e9d3',
  mapKey: 'AIzaSyCxs8F9SsgeNJy6lco0weql_YxCKRy5lgo',

  clientId:'08aecf67-3ddb-4ccd-9cc6-67a83e1bd8dc',
  tenentId:'4fc2f3aa-31c4-4dcb-b719-c6c16393e9d3',
  authority:'https://login.microsoftonline.com/4fc2f3aa-31c4-4dcb-b719-c6c16393e9d3',
  redirectUri:'https://clienta-test.controlunion.com/home/events',
  loginFailedRoute:'https://clienta-test.controlunion.com/signin',
  openUrls:[],
  disableTosterUrl:[],
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
